import { render } from "./ModalRecoveryPassword.vue?vue&type=template&id=40c0e644&scoped=true"
import script from "./ModalRecoveryPassword.vue?vue&type=script&lang=js"
export * from "./ModalRecoveryPassword.vue?vue&type=script&lang=js"

import "./ModalRecoveryPassword.vue?vue&type=style&index=0&id=40c0e644&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c0e644"]])

export default __exports__